<template>
  <div class="modal-mask">
    <div class="ui small modal">
      <div class="header">{{title}}</div>
      <div class="content">
        <div class="ui bottom attached message flex" :class="{'error': type==='ERROR', 'success': type==='INFO'}" v-for="(msg, index) in convertArray(message)" :key="index">
          <i class="circle icon" :class="{'times': type==='ERROR', 'check': type==='INFO'}"></i>
          <div class="newline message">{{msg}}</div>
        </div>
      </div>
      <div class="actions">
        <div class="ui button" @click="close">{{btnLabel}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: String,
    title: String,
    message: [String, Array],
    btnLabel: String,
    callback: Function
  },
  methods: {
    close: function () {
      this.callback()
      this.$store.commit('infoModal/closeModal')
    },
    convertArray: function (message) {
      return typeof message === 'string' ? [message] : message
    }
  }
}
</script>
<style scoped>
.modal-mask {
  background-color: rgba(0, 0, 0, 0.7);
  display: block;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}
.ui.modal {
  background-color: white;
  display: block;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.ui.message.flex {
  display: flex;
  position: relative;
}

.ui.message.flex > .icon {
  position: absolute;
  top: 50%;
  margin-top: -10px;
}

.ui.message.flex > .message {
  margin-left: 25px;
}
</style>
